import type { MutableRefObject } from 'react';
import { Row, theme } from 'antd';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';
import type { ScheduleBoardBlockedSlotModel } from 'pos-shared/models/schedulingSchema.ts';

import { BlockedSlotContent } from './BlockedSlotContent.tsx';
import { BlockedSlotTooltip } from './BlockedSlotTooltip.tsx';

interface BlockedSlotProps {
  slotData: ScheduleBoardBlockedSlotModel;
  targetChildRef: MutableRefObject<HTMLDivElement | null>;
}

export const BlockedSlot = ({ slotData, targetChildRef }: BlockedSlotProps) => {
  const { token } = theme.useToken();
  const textColor = useJobStatusTextColor(slotData.state);

  return (
    <BlockedSlotTooltip slotData={slotData}>
      <Row
        ref={targetChildRef}
        style={{
          padding: token.paddingXS,
          backgroundImage:
            'repeating-linear-gradient(-45deg, rgba(197, 197, 197, 0.3) 5px, rgba(197, 197, 197, 0.3) 6px, transparent 6px, transparent 10px)',
          color: textColor,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          borderRadius: 'inherit',
        }}
      >
        <BlockedSlotContent slotData={slotData} />
      </Row>
    </BlockedSlotTooltip>
  );
};
